import React from 'react';

import { Button } from '../../../interfaces';

export const SimpleButton: React.FC<Button> = React.memo((props: Button) => {
  const { children, label, type, ...rest } = props;
  return (
    <button
      {...rest}
      className="fr-btn fr-btn--lg"
      type={rest.onClick ? 'button' : type || 'submit'}>
      {label || children}
    </button>
  );
});

SimpleButton.displayName = 'SimpleButton';
